<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">塾切替</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="modified" rounded depressed small @click="onRefresh()">
              <span class="px-1 text-none">中止</span>
            </v-btn>
            <v-btn v-if="modified" dark rounded depressed small color="error" class="mx-1" @click.native="updateDialog = true">
              <span class="text-none">切替</span>
            </v-btn>
            <v-chip outlined depressed color="primary">{{ '既定: ' + getPrimarySchool() }}</v-chip>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="12" class="px-0">
            <v-col v-if="$route.path != '/setting'" cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0" align="center">
                  <v-icon>mdi-shield-account</v-icon>
                </v-col>
                <v-col cols="9" class="pa-0">
                  <span>多重ログイン</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="tempUser.multi"
                    color="error"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                  >
                  </v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col  v-if="tempUser.multi" cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0" align="center"></v-col>
                <v-col cols="10" class="pa-0">
                  <v-row class="ma-0 py-0" align="center">
                    <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                      <v-row align="center" justify="center" style="height:48px;">
                        <v-col :cols="header.width"  :align="header.align" class="pa-0" v-for="(header, index) in headersSchools" :key="header.key">
                          <v-sheet class="pa-0 customHeader" color="transparent">
                            <template v-if="header.valid">
                              <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                              <v-icon :color="headersSchools[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                            </template>
                            <template v-else>
                              <span>{{ header.title }}</span>
                            </template>
                          </v-sheet>
                        </v-col>
                        <v-col class="pa-0" align="center">
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pa-0" align="center">
                      <div class='overflow-y-auto'>
                        <RecycleScroller
                          class="scroller"
                          :items="mySchools"
                          :item-size="44"
                          key-field="key"
                        >
                          <template v-slot="{ item }">
                            <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                              <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                                <v-col :cols="header.width" class="pa-0" align="start" v-for="(header) in headersSchools" :key="header.key">
                                  <template v-if="header.key == 'select'">
                                    <v-row class="ma-0 pa-0" align="center">
                                      <v-col cols="12" class="py-0" align="center">
                                        <v-btn icon @click.stop="onSchoolChange(item)">
                                          <v-icon v-if="item.key == schoolsCurrent">mdi-radiobox-marked</v-icon>
                                          <v-icon v-else>mdi-radiobox-blank</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <template v-else-if="header.key == 'name'">
                                    <v-row class="ma-0 pa-0" align="center">
                                      <v-col cols="2" class="pa-0">
                                        <v-avatar size="30">
                                          <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                          <v-avatar v-else size="30" color="primary"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                                        </v-avatar>
                                      </v-col>
                                      <v-col class="pa-0">
                                        <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <template v-else-if="header.key == 'classType'">
                                    <v-chip small :color="item.classroom ? 'primary' : 'success'"><span >{{ item[header.key] }}</span></v-chip>
                                  </template>
                                </v-col>
                              </v-row>
                            </v-sheet>
                          </template>
                        </RecycleScroller>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="pa-0" align="center"></v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='切替'
        message='ログインする塾を切り替えます。切替を行うと自動的にログアウトします。よろしいですか？'
        :dialog='updateDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: [ 'item', 'dialog', 'type' ],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      privilege: 'shared/privilege',
      windowSize: 'shared/windowSize'
    }),
    mySchools () {
      var temp = []
      for (var i in this.schools) {
        if (this.$route.path !== '/setting') {
          temp.push(JSON.parse(JSON.stringify(this.schools[i])))
        } else if (typeof this.tempUser.schools[this.schools[i].key] !== 'undefined') {
          temp.push(JSON.parse(JSON.stringify(this.schools[i])))
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      updateDialog: false,
      modified: false,
      school: null,
      selected: null,
      schoolsSelected: {},
      schoolsCurrent: null,
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      headersSchools: [
        { valid: false, over: false, value: 0, title: '種別', key: 'select', width: '2', align: 'center' },
        { valid: false, over: false, value: 0, title: '名称', key: 'name', width: '9', align: 'start' }
      ],
      edit: true,
      tempUser: null,
      loading: false
    }
  },
  watch: {
    item () {
      this.initital()
    },
    schoolsSelected () {
      var keys = Object.keys(this.schoolsSelected)
      for (var i in keys) {
        if (keys[i] === this.schoolsCurrent) {
          return
        }
      }
      this.schoolsCurrent = this.tempUser.primary
    }
  },
  created () {
    this.initital()
  },
  methods: {
    initital () {
      this.tempUser = JSON.parse(JSON.stringify(this.item))
      if (typeof this.tempUser.chatsShare === 'undefined') {
        this.tempUser['chatsShare'] = false
        this.tempUser['chatsCreate'] = false
      }
      if (typeof this.tempUser.multi === 'undefined') {
        this.tempUser['multi'] = false
      }
      if (typeof this.tempUser.primary === 'undefined') {
        this.tempUser['primary'] = null
      }
      if (!this.tempUser.schools) {
        return
      }
      this.schoolsSelected = {}
      var keys = Object.keys(this.tempUser.schools)
      for (var i in keys) {
        this.schoolsSelected[keys[i]] = true
      }
      for (i in keys) {
        if (this.tempUser.schools[keys[i]]) {
          this.school = keys[i]
          this.schoolsCurrent = keys[i]
          if (this.tempUser.primary === null) {
            this.tempUser['primary'] = this.school
          }
          break
        }
      }
    },
    checkDisabled (item) {
      if (this.getPrivilegesLevel(this.data) === 0) {
        return item.key === this.tempUser.primary
      }
      return true
    },
    getNamePrefixFromItem (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getPrimarySchool () {
      if (typeof this.tempUser.primary !== 'undefined') {
        var index = this.schools.findIndex(s => s.key === this.tempUser.primary)
        if (index !== -1) {
          return this.schools[index].name
        }
      }
      return '-'
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onClose () {
      this.$emit('dismissed')
    },
    onChangeSelected (item) {
      var keys = Object.keys(this.schoolsSelected)
      this.modified = true
      for (var i in keys) {
        if (this.schoolsSelected[keys[i]] && keys[i] === this.schoolsCurrent) {
          return
        }
      }
      this.schoolsCurrent = this.tempUser.primary
    },
    onSchoolChange (item) {
      var keys = Object.keys(this.schoolsSelected)
      for (var i in keys) {
        if (this.schoolsSelected[keys[i]] && keys[i] === item.key) {
          this.schoolsCurrent = item.key
          this.modified = true
          return
        }
      }
    },
    onDismissed: function (result) {
      this.updateDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onUpdate () {
      var vm = this
      var reboot = false
      if (this.school !== this.schoolsCurrent) {
        for (var i in this.schools) {
          if (this.schools[i].key === this.schoolsCurrent) {
            localStorage.id = this.schools[i].id
            localStorage.school = this.schools[i].key
            reboot = true
            break
          }
        }
      }
      this.loading = true
      var payload = this.tempUser
      var schools = {}
      if (this.tempUser.multi) {
        var keys = Object.keys(this.schoolsSelected)
        for (i in keys) {
          schools[keys[i]] = false
        }
        schools[this.schoolsCurrent] = true
      } else {
        schools[this.school] = true
      }
      payload.schools = schools
      this.$store.dispatch('users/write', JSON.parse(JSON.stringify(payload))).then(() => {
        vm.loading = false
        vm.file = null
        vm.modified = false
        vm.$emit('dismissed')
        if (reboot) {
          vm.forceLogout()
        }
      })
    },
    forceLogout () {
      var vm = this
      this.$nextTick(function () {
        vm.gisSignOut()
        vm.$store.dispatch('auth/release').then(() => {
          vm.goto(vm, '/')
        })
      })
    },
    onRefresh () {
      this.initital()
      this.modified = false
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
